export default __webpack_public_path__ + "right-icon-blue.svg";